import {useContext} from "react";
import {EchoContext} from "joynt/websockets/EchoProvider";

export default function useEcho() {
    return useContext(EchoContext);
}